import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectIcon32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMediaObjectIcon32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 7h8c.386 0 .746.11 1.051.298L11 14.292 5.949 7.298A2 2 0 0 1 7 7m2.766 9L5 9.4v13.2zM5.95 24.702 11 17.708l5.051 6.994A2 2 0 0 1 15 25H7a2 2 0 0 1-1.051-.298M12.233 16 17 9.4v13.2zM3 9a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4zm18 0a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectIcon32);
